import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "pull-right small text-sm-right" }
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlbumItem = _resolveComponent("AlbumItem")!
  const _component_ArtistItem = _resolveComponent("ArtistItem")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_mavon_editor = _resolveComponent("mavon-editor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
    title: _ctx.dialogTitle
  }, {
    footer: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogFormVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doConfirmEdit()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _ctx.loadings.formLoading]
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.type=='album')
        ? (_openBlock(), _createBlock(_component_AlbumItem, {
            key: 0,
            album: _ctx.album,
            "show-type": "album-card-h",
            class: "mt-3 mb-3"
          }, null, 8, ["album"]))
        : _createCommentVNode("", true),
      (_ctx.type=='artist')
        ? (_openBlock(), _createBlock(_component_ArtistItem, {
            key: 1,
            artist: _ctx.artist,
            "show-type": "artist-card-h",
            class: "mt-3 mb-3"
          }, null, 8, ["artist"]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        model: _ctx.formEditRank,
        "status-icon": "",
        "label-width": "80px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formEditRank.rank_version_index,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formEditRank.rank_version_index) = $event)),
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rank_versions, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item._id,
                    label: item.title,
                    value: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(item.title) + " ", 1),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formatTS(item.ts_updated)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_switch, {
              modelValue: _ctx.formEditRank.rank_in_head,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formEditRank.rank_in_head) = $event)),
              "active-text": "添加到头",
              "inactive-text": "添加到尾",
              class: "ml-3"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_mavon_editor, {
            ref: "md",
            modelValue: _ctx.formEditRank.content,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formEditRank.content) = $event)),
            "box-shadow": false,
            onImgAdd: _ctx.doImgAdd,
            onImgDel: _ctx.imgDel,
            onSave: _ctx.doConfirmEdit
          }, null, 8, ["modelValue", "onImgAdd", "onImgDel", "onSave"])
        ]),
        _: 1
      }, 8, ["model"])), [
        [_directive_loading, _ctx.loadings.formLoading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}